import { StudentClassificationStatus } from '../types/studentClassification';
import {
  DEFAULT_STUDENT_TENURE_FILTER,
  type StudentTenureFilter,
} from '../types/studentTenure';

const ALLOWED_CLASSIFICATIONS = new Set<string>(Object.values(StudentClassificationStatus));

export function parseClassificationFilters(values: string[] | undefined): string[] {
  if (!values?.length) {
    return [];
  }

  return values.filter((value) => ALLOWED_CLASSIFICATIONS.has(value));
}

export function classificationsFromLegacyTenure(tenure: StudentTenureFilter): string[] {
  if (tenure === 'new') {
    return [StudentClassificationStatus.NEW_STUDENT];
  }

  if (tenure === 'established') {
    return [StudentClassificationStatus.OLD_STUDENT];
  }

  return [];
}

export function resolveJourneyClassificationFilters(
  classifications: string[] | undefined,
  tenure: StudentTenureFilter = DEFAULT_STUDENT_TENURE_FILTER,
): string[] {
  const selected = parseClassificationFilters(classifications);
  if (selected.length > 0) {
    return selected;
  }

  return classificationsFromLegacyTenure(tenure);
}
